import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "remix-icon-vuejs-fill",
  "use": "remix-icon-vuejs-fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"remix-icon-vuejs-fill\"><path fill=\"none\" d=\"M0 0h24v24H0z\" /><path d=\"M1 3h4l7 12 7-12h4L12 22 1 3zm8.667 0L12 7l2.333-4h4.035L12 14 5.632 3h4.035z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol